import * as React from 'react';
import AddFleetForm from './../Layout/Form/AddFleet';
import * as FleetModule from 'Modules/FleetModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { connect } from 'react-redux';
import {RootState} from "Redux/Reducers/_RootReducer";
import * as UserModule from "Modules/UserModule";
import {createSerachQuery} from "Connectors/_main";
import {IAdditionalLoadOptions} from "components/Layout/Form/Fields/AutoCompleteField";

type P = {
    match: any;
    history: any;
};

type S = {
    //
};

type DispatchedP = {
    manageFleetCars: (type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto) => Function;
    createFleet: (data: FleetModule.Types.AddFleetRequest) => Function;
    deleteCarFromFleet: (carId: number, fleetId: number) => Function;
    showVehicleList: () => Function;
    getFleetById: (fleetId: number) => Function;
    setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => Function;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => Function;
    deleteFleet: (fleetId: number) => Function;
    updateFleet: (fleetId: number, fleetData: FleetModule.Types.AddFleetRequest) => Function;
    getCars: Function;
    getUsersFleet: Function;
    clearVehiclesList: () => void
    clearUserList: () => void
    getUsers: (queryParams?: URLSearchParams) => Promise<UserModule.Types.UserListDataResponse>
};

type ConnectedP = {
    fleetStore: FleetModule.Types.FleetStore
    activeUser: UserModule.Types.UserDto
};

const getSelectOption = ({ id, firstName, lastName }: UserModule.Types.UserDto) => ({ value: id, label: `${firstName} ${lastName}` })
class ManageFleet extends React.Component<P & ConnectedP & DispatchedP, S> {
    constructor(props: P & ConnectedP & DispatchedP) {
        super(props);
        this.handleFleetSubmit = this.handleFleetSubmit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    private async handleFleetSubmit(formData) {
        const newFleetData: FleetModule.Types.AddFleetRequest = {
            name: formData.name,
            carIds: formData.carIds.map((e, i) => e.id),
            authorId: formData.fleetOwner.value
        };
        if (this.props.match.params.fleetId) {
            await this.props.updateFleet(this.props.match.params.fleetId, newFleetData);
        } else {
            await this.props.createFleet(newFleetData);
        }
    }
    public async componentDidMount() {
        if (this.props.match.params.fleetId) {
            await this.props.getFleetById(this.props.match.params.fleetId);
        }

        await this.props.getCars();
    }
    private async handleDelete(car: VehiclesModule.Types.CarDto) {
        this.props.manageFleetCars('DELETE', car);
    }

    private fetchUsers = async (search: string, additional: IAdditionalLoadOptions) => {
      const params = createSerachQuery(
        [
          { id: 'first', value: additional.first },
          { id: 'fullName', value: search },
        ]
      )

      const response = await this.props.getUsers(params)

      return {
        options: response.userList.map(getSelectOption),
      }
    }

    public async componentWillUnmount() {
      this.props.clearVehiclesList();
      this.props.clearUserList();
      await this.props.setActiveFleet(null);
    }
    public render() {
        const {
          fleetStore,
          showVehicleList,
          match,
          activeUser
        } = this.props;
        let initialValues = {};
        if (match.path === '/fleet/add') {
            initialValues = {
              carIds: fleetStore.manageFleetCars,
              fleetOwner: getSelectOption(activeUser)
            };
        } else if (fleetStore.activeFleet && match.params.fleetId) {
            initialValues = {
              carIds: fleetStore.manageFleetCars,
              name: fleetStore.activeFleet.name,
              fleetOwner: getSelectOption(fleetStore.activeFleet.author)
            };
        }

        // Po wróceniu do formularza np. z pojazdu
        if (fleetStore.cachedChangedValues) {
          initialValues = fleetStore.cachedChangedValues
        }

        return (
            <div className="main__content">
                <AddFleetForm
                    onSubmit={this.handleFleetSubmit}
                    initialValues={initialValues}
                    fetchUsers={this.fetchUsers}
                    {...{
                        onDelete: car => this.handleDelete(car),
                        showVehicleList
                    }}
                />
            </div>
        );
    }
}

function mapStateToProps(state: RootState): ConnectedP {
    return {
        fleetStore: state.fleetStore,
        activeUser: state.userStore.user,
    };
}

function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        manageFleetCars: (type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto) => dispatch(FleetModule.Actions.manageFleetCars(type, car)),
        deleteCarFromFleet: (fleetId: number, carId: number) => dispatch(FleetModule.Actions.deleteCarFromFleet(fleetId, carId)),
        deleteFleet: (fleetId: number) => dispatch(FleetModule.Actions.deleteFleet(fleetId)),
        createFleet: (newFleetData: FleetModule.Types.AddFleetRequest) => dispatch(FleetModule.Actions.createFleet(newFleetData)),
        updateFleet: (fleetId: number, fleetData: FleetModule.Types.AddFleetRequest) => dispatch(FleetModule.Actions.updateFleet(fleetId, fleetData)),
        showVehicleList: () => dispatch(ViewManagementModule.Actions.showVehicleList()),
        getFleetById: (fleetId: number) => dispatch(FleetModule.Actions.getFleetById(fleetId)),
        setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => dispatch(FleetModule.Actions.setActiveFleet(fleet)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData)),
        getCars: () => dispatch(VehiclesModule.Actions.getCars()),
        getUsersFleet: () => dispatch(FleetModule.Actions.getUsersFleet()),
        clearVehiclesList: () => dispatch(VehiclesModule.Actions.clearVehiclesList()),
        getUsers: (queryParams?: URLSearchParams) => dispatch(UserModule.Actions.getFleetUsers(queryParams)),
        clearUserList: () => dispatch(UserModule.Actions.clearUserList())
    };
}

export default connect(
    mapStateToProps,
    mapDispachToProps
)(ManageFleet);



// WEBPACK FOOTER //
// ./src/components/Fleet/ManageFleet.tsx